const breadcrumbsHome = { name: 'Home', pathName: '/' }

export default [
  {
    path: '/feature-branch',
    component: () => import('@/modules/feature_branch/FeatBranchList.vue'),
    meta: {
      title: 'Feature-Branch Setup',
      breadcrumbs: [breadcrumbsHome]
    }
  }
]
